import controller from "emun.cart/checkout.controller";
import "emun.cart/checkout.scss";
import views from "emun.cart/checkout/checkout.views";

export default {
  bindings: {
    cartId: "@",
    token: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return (
      $attrs.templateUrl ||
      views[$attrs.layout || $attrs.view || $attrs.type] ||
      views.main
    );
  },
};
